<template>
  <div class="dialog-wrap" v-if="isConfirmDialogShow">
    <div class="cover"></div>
    <div class="confirm-dialog">
      <div class="header">
        <img @click="isConfirmDialogShow = false" src="@/assets/img/dialog/close-grey.png" alt="" />
      </div>
      <div class="logo">
        <img class="img1" :src="bannedUserVal.avatar ? bannedUserVal.avatar : require('@/assets/img/default/default_logo1.png')" alt="" />
        <img class="img2" :src="bannedUserNoble" alt="" />
      </div>
      <div class="name">
        <div>{{ bannedUserVal.nick_name }}</div>
        <img :src="levelToPicture(bannedUserVal.level)" alt="" />
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm">
        <el-form-item label="禁言时长" prop="time">
          <el-select v-model="ruleForm.time" placeholder="请选择禁言时长" @change="changeBannedTime">
            <el-option :label="item.name" :value="item.value" v-for="(item, index) in bannedTimeList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="禁言原因" prop="reason">
          <el-select v-model="ruleForm.reason" placeholder="请选择禁言原因" @change="changeBannedReason">
            <el-option :label="item.name" :value="{ value: item.value, label: item.name }" v-for="(item, index) in bannedReasonList" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div v-show="!isBannedBtnShow" class="btn">禁言</div>
      <div @click="blockUserConfirm()" v-show="isBannedBtnShow" class="btn btn-active">禁言</div>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { levelToPicture } from "@/util/picNumber";
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  props: ["bannedUserVal"],

  data() {
    return {
      isConfirmDialogShow: false,
      ruleForm: {
        time: "",
        reason: "",
      },
      rules: {
        time: [{ required: true, message: "", trigger: "change" }],
        reason: [{ required: true, message: "", trigger: "change" }],
      },
      bannedTimeList: [
        { name: "30分钟", value: 30 * 60 },
        { name: "2小时", value: 3600 * 2 },
        { name: "6小时", value: 3600 * 6 },
        { name: "1天", value: 3600 * 24 },
        { name: "7天", value: 3600 * 24 * 7 },
        { name: "永久", value: 4294967295 },
      ],
      bannedReasonList: [
        { name: "广告营销诈骗", value: 1 },
        { name: "低俗色情", value: 2 },
        { name: "不实信息", value: 3 },
        { name: "辱骂谩骂", value: 4 },
        { name: "违法有害信息", value: 5 },
        { name: "涉政言论", value: 6 },
        { name: "其他", value: 7 },
      ],
      isBanneding: false,
      bannedTime: 0,
      bannedReason: null,
      isBannedBtnShow: false,
      bannedUser: {},
      bannedUserLevel: require("@/assets/img/level-user/1.png"),
      bannedUserNoble: require("@/assets/img/noble/0.png"),
    };
  },
  computed: {
    ...mapState(["userInfo", "groupMessageList"]),
  },
  methods: {
    ...mapMutations(["changeGroupMessageList"]),
    levelToPicture,
    open() {
      this.isConfirmDialogShow = true;
    },
    confirm() {
      this.$emit("confirmDialog", this.content);
      this.isConfirmDialogShow = false;
    },
    changeBannedTime(e) {
      console.log(e);
      this.bannedTime = e;
      if (this.bannedTime && this.bannedReason) {
        this.isBannedBtnShow = true;
      }
    },
    changeBannedReason(e) {
      console.log(e.label, e.value);
      this.bannedReason = e;
      if (this.bannedTime && this.bannedReason) {
        this.isBannedBtnShow = true;
      }
    },
    blockUserConfirm() {
      if (this.isBanneding) return;
      this.isBanneding = true;
      post({
        url: "/api/groupChat/banUser",
        data: { ban_user_id: this.bannedUserVal.uid, duration: this.bannedTime, fans_group_id: this.bannedUserVal.group_id, reason: this.bannedReason.label },
      })
        .then(({ data: { msg } }) => {
          if (msg === "SUCCESS") {
            this.isConfirmDialogShow = false;
            this.$message.success("禁言成功");
            this.isBanneding = false;
            let filterBannedMsg = this.groupMessageList.filter((e) => e.uid !== this.bannedUserVal.uid);
            this.changeGroupMessageList(filterBannedMsg);
          }
        })
        .catch((e) => {
          console.log("err: ", e);
          this.isBanneding = false;
        });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-form-item {
  margin-bottom: 0.05rem;
}
::v-deep .el-form-item__label {
  font-size: 0.12rem;
  margin-left: 0.25rem;
}
::v-deep .el-input__inner {
  width: 1.3rem;
  height: 0.26rem;
  line-height: 0.26rem;
  padding-left: 0.05rem;
  font-size: 0.12rem;
}
.dialog-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
}
.cover {
  position: absolute;
  left: 0px;
  top: 0px;
  background: rgba(0, 0, 0, 0.4);
  width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
  height: 100%;
  z-index: 998;
}
.confirm-dialog {
  width: 2.5rem;
  height: 3.26rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // width: 2.8rem;
  background: #ffffff;
  border-radius: 0.1rem;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  z-index: 999;
  // padding: 0.24rem 0;
  .header {
    padding-right: 0.12rem;
    padding-top: 0.12rem;
    display: flex;
    justify-content: flex-end;
    img {
      width: 0.12rem;
      height: 0.12rem;
      cursor: pointer;
    }
  }
  .logo {
    display: flex;
    justify-content: center;
    .img1 {
      width: 0.6rem;
      height: 0.6rem;
      border-radius: 50%;
    }
    .img2 {
      position: absolute;
      width: 0.64rem;
      height: 0.64rem;
      left: 0.93rem;
      top: 0.22rem;
    }
  }
  .name {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.2rem;
    margin-bottom: 0.2rem;
    color: #333;
    font-size: 0.16rem;
    img {
      height: 0.18rem;
      margin-left: 0.03rem;
    }
  }
  .btn {
    width: 1.12rem;
    height: 0.34rem;
    background: #c4cacc;
    color: #fff;
    font-size: 0.16rem;
    border-radius: 0.34rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2rem auto 0;
    cursor: not-allowed;
  }
  .btn-active {
    cursor: pointer;
    background: #02a8a2;
  }
}
</style>
